var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-pro bg-white"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "service-content"
  }, [_c('div', {
    staticClass: "service-card"
  }, [_c('div', {
    staticClass: "title-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrlSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), (!_vm.isYxg) ? _c('div', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.txt))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "service-btn",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), (!_vm.isYxg) ? _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("服务2： 关注众赢财富通" + _vm._s(_vm.serviceName) + "号")]) : _vm._e(), _vm._v(" "), (!_vm.isYxg) ? _c('div', {
    staticClass: "qr-code"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrsrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content"
  }, [_vm._v("1." + _vm._s(_vm.messageTitle))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("2.长按识别关注" + _vm._s(_vm.serviceName) + "号最新课程一手掌握")])])])]) : _vm._e()])]), _vm._v(" "), _c('span', {
    attrs: {
      "hidden": ""
    }
  }, [_vm._v(_vm._s(_vm.order))])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-bg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ServiceOpening.jpg",
      "alt": ""
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-6aa46b7e","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderServiceComplete.vue
// module id = 239
// module chunks = 0